/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Config setter and getter (@accedo/xdk-config) 4.2.3
* 
*******************************************************************************/
const PlayerConfig=function({id:i,importer:t,extensions:e=[],config:n}){this.default=!1,this.id=i,this.importer=t,this.extensions=e,this.config=n};export default PlayerConfig;